/**
 * The string field type
 *
 * @group ISOBMFF
 *
 * @beta
 */
export const STRING = 'string';
